/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DatePresetType } from '../models/DatePresetType';
import type { ServiceBookingPerfomanceDto } from '../models/ServiceBookingPerfomanceDto';
import type { VehicleConditionEditModel } from '../models/VehicleConditionEditModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServiceBookingService {

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteServiceBooking(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/service-booking/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServiceBooking(
requestBody?: VehicleConditionEditModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/service-booking',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }


  /**
   * @param email 
   * @param regno 
   * @param id 
   * @returns number Success
   * @throws ApiError
   */
  public static getServiceBookingVauchers(
email?: string,
regno?: string,
id?: number,
): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/vauchers',
      query: {
        'email': email,
        'regno': regno,
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param datePreset
 *
 * 0 = Period
 *
 * 1 = Day
 *
 * 2 = Week
 *
 * 3 = Month
   * @param dateFrom 
   * @param dateTo 
   * @param branchId 
   * @param departmentId 
   * @param employeeName 
   * @returns ServiceBookingPerfomanceDto Success
   * @throws ApiError
   */
  public static getServiceBookingPerfomance(
datePreset: DatePresetType,
dateFrom?: string,
dateTo?: string,
branchId?: number,
departmentId?: number,
employeeName?: string,
): CancelablePromise<ServiceBookingPerfomanceDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/service-booking/perfomance',
      query: {
        'datePreset': datePreset,
        'dateFrom': dateFrom,
        'dateTo': dateTo,
        'branchId': branchId,
        'departmentId': departmentId,
        'employeeName': employeeName,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
